import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PadAgreementLog } from '@app/models/payroll/pad-agreement-log.model';
import { AuthService } from '@app/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const ACCEPT_TOS_ENDPOINT = '/v2/companyManagement/companies/:company/acceptTos';
const PAD_AGREEMENT_ENDPOINT = '/v2/companyManagement/padAgreement';
const PAD_AGREEMENT_STATUS_ENDPOINT = '/v2/companyManagement/padAgreement/status';
const PAD_AGREEMENT_LOGS_ENDPOINT = '/v2/companyManagement/padAgreement/logs';
const BANK_ACCOUNT_REATTEST_ENDPOINT = '/v2/companyManagement/companies/:company/bankAccounts/:bankAccount/reattest';

export interface BankAccountReattestAttributes {
    accountNumber: string;
    branchNumber: string;
    institutionNumber: string;
}

@Injectable({ providedIn: 'root' })
export class CompanyMetaService {
    constructor(
        private readonly http: HttpClient,
        private auth: AuthService
    ) {}

    setTosComplete(email: string): Promise<unknown> {
        const url = ACCEPT_TOS_ENDPOINT.replace(':company', this.auth.company.id.toString());
        const payload = {
            data: {
                type: 'companyMeta',
                attributes: {
                    tos_accepted_email: email,
                },
            },
        };
        return this.http.post(url, payload).toPromise();
    }

    async acceptPadAgreement(): Promise<unknown> {
        const url = PAD_AGREEMENT_ENDPOINT;
        const payload = {
            data: {
                type: 'padAgreementAcceptance',
                attributes: {},
            },
        };
        return this.http.post(url, payload).toPromise();
    }

    getPadAgreementLogs$(): Observable<PadAgreementLog[]> {
        return this.http
            .get<{ data: { attributes: PadAgreementLog }[] }>(PAD_AGREEMENT_LOGS_ENDPOINT)
            .pipe(map((response) => response?.data?.map((item) => item.attributes) ?? []));
    }

    async getPadAgreementStatus(): Promise<boolean> {
        const url = PAD_AGREEMENT_STATUS_ENDPOINT;
        try {
            const response = (await this.http.get(url).toPromise()) as {
                data: { attributes: { accepted: boolean } };
            };
            return response?.data?.attributes?.accepted === true;
        } catch (error) {
            return false;
        }
    }

    // Updates the bank account, records PAD, and syncs to Payroll atomically (no manual save+accept).
    reattestBankAccount(
        companyId: number,
        bankAccountId: number,
        attributes: BankAccountReattestAttributes
    ): Promise<unknown> {
        const url = BANK_ACCOUNT_REATTEST_ENDPOINT.replace(':company', companyId.toString()).replace(
            ':bankAccount',
            bankAccountId.toString()
        );
        const payload = {
            data: {
                type: 'bankAccounts',
                attributes,
            },
        };
        return this.http.post(url, payload).toPromise();
    }
}
